import React from 'react'

import HARDCODE from '../../../business-const/HardCode/HardCode'

import LABEL from '../../../business-const/Label/Label'

//import LABELESPECIAL from '../../../business-const/Label/LabelEspecial'

import MESSAGE from '../../../business-const/Message/Message'

import {
    formataPerc,
    formataTableCellHeadExibeDadosTexto,
    formataTableCellHeadExibeDadosValor,
    formataTableCellBodyExibeDadosTexto,
    formataTableCellBodyExibeDadosValor,
    formataTableCellBodyExibeDadosPerc,
} from '../../../business-components/Formata/Formata'

import {
    DivOverflowX,
} from '../../../business-components/Div/Div'

import {
    GridContainer,
    //GridItem8,
    GridItem11,
} from '../../../business-components/Grid/Grid'

//import {
//    CardGridEstudo,
//} from '../../../business-components/Card/Card'

import {
    TableExibeDados,
    TableHeadExibeDados,
    TableRowHeadExibeDados,
    TableBodyExibeDados,
    TableRowBodyExibeDados,
    TableCellBodyExibeDados,
} from '../../../business-components/Table/TableExibeDados'

import {
    anoPrimeiraLetraMaiscula,
    relatorioModoApresentacao,
} from './EstudoService'

import TabelaEvolucaoValorResgateChart from '../estudo-chart/TabelaEvolucaoValorResgateChart'

//import {
    //CardGridEstudoTabelaPadrao,
//} from '../estudo-form/EstudoComp'



const EstudoFormTabelaEvolucaoValorResgate = ( { values, estudo, estrategiasFinanceirasTabelaEvolucaoValorResgate, report,
    indInicial, indFinal } ) => {

    const TabelaEvolucaoValorResgate = () => {

        const aumentoLetraCabecalho = 4
        const aumentoLetraReportCabecalho = values.disposicaoRelatorio === HARDCODE.disposicaoRelatorioRetrato ? 3 : 5
        
        const aumentoLetra = 3//4
        const aumentoLetraReport = values.disposicaoRelatorio === HARDCODE.disposicaoRelatorioRetrato ? 4 : 6

        let colSpan = values.exibirPercPremioAnualizadoAcumuladoEmRelacaoCapitalSegurado ? 1 : 0 

        let headList = [
            {
                colSpan: 2,
                headTitle: formataTableCellHeadExibeDadosTexto(anoPrimeiraLetraMaiscula(), report, aumentoLetraCabecalho,
                    aumentoLetraReportCabecalho, values),
            },
            {
                colSpan: 2,
                headTitle: formataTableCellHeadExibeDadosTexto(LABEL.idade, report, aumentoLetraCabecalho,
                    aumentoLetraReportCabecalho, values),
            },
            {
                colSpan: 3,
                headTitle: formataTableCellHeadExibeDadosValor(LABEL.valorCS, report, aumentoLetraCabecalho,
                    aumentoLetraReportCabecalho, values),
            },
        ]

        if (values.exibirPercPremioAnualizadoAcumuladoEmRelacaoCapitalSegurado) {

            headList.push(
                {
                    colSpan: 2,
                    headTitle: formataTableCellHeadExibeDadosValor(LABEL.perc, report, aumentoLetraCabecalho,
                        aumentoLetraReportCabecalho, values),
                },
            )
        }

        headList.push(
            {
                colSpan: 3,
                headTitle: formataTableCellHeadExibeDadosValor(LABEL.valorPremioAnualizado, report, aumentoLetraCabecalho,
                    aumentoLetraReportCabecalho, values),
            },
            {
                colSpan: 3,
                headTitle: formataTableCellHeadExibeDadosValor(LABEL.valorPremioAnualizadoAcumulado, report,
                    aumentoLetraCabecalho, aumentoLetraReportCabecalho, values),
            },
            {
                colSpan: 3,
                headTitle: formataTableCellHeadExibeDadosValor(LABEL.valorResgate, report, aumentoLetraCabecalho,
                    aumentoLetraReportCabecalho, values),
            },
        )

        ////if (values.exibirEconomiaInventarioSeguroVidaTabelaEvolucaoValorResgate) {

        ////    headList.push(
        ////        {
        ////            colSpan: 3,
        ////            headTitle: formataTableCellHeadExibeDadosValor(LABEL.valorEconomiaInventarioSeguroVida, report),
        ////        },
                //{
                //    colSpan: 3,
                //    headTitle: formataTableCellHeadExibeDadosValor(LABEL.valorResgateMaisEconomiaInventarioSeguroVida, report),
                //},
        ////    )
        ////}



        return (
            <>
                {(report || values.modoApresentacao) && (!indInicial || indInicial === 0) && (
                    <div
                        className='mb-3'
                    >
                        <TabelaEvolucaoValorResgateChart
                            values={values}
                            estudo={estudo}
                            estrategiasFinanceirasTabelaEvolucaoValorResgate={estrategiasFinanceirasTabelaEvolucaoValorResgate}
                            report={report}
                            tabelaEvolucaoValorResgate={true}
                        />
                    </div>
                )}

                <TableExibeDados
                    report={report}
                    noMinW={true}
                >
                    <TableHeadExibeDados
                        report={report}
                    >
                        <TableRowHeadExibeDados
                            dados={headList}
                        />
                    </TableHeadExibeDados>

                    <TableBodyExibeDados>
                        {estrategiasFinanceirasTabelaEvolucaoValorResgate.tabelaEvolucaoValorResgate?.map((item, ind) => {
                            return (!indFinal || (ind >= indInicial && ind <= indFinal)) && (
                                <TableRowBodyExibeDados
                                    key={ind}
                                    report={report}
                                >
                                    <TableCellBodyExibeDados
                                        colSpan={headList[0].colSpan}
                                        primeiraColuna={true}
                                        bold={item.bold}
                                    >
                                        {formataTableCellBodyExibeDadosTexto(item.ano, report, item.bold,
                                            aumentoLetra, aumentoLetraReport, values)}
                                    </TableCellBodyExibeDados>
                                    
                                    <TableCellBodyExibeDados
                                        colSpan={headList[1].colSpan}
                                        bold={item.bold}
                                    >
                                        {formataTableCellBodyExibeDadosTexto(item.idadeFamiliarCotacao, report,
                                            item.bold, aumentoLetra, aumentoLetraReport, values)}
                                    </TableCellBodyExibeDados>

                                    <TableCellBodyExibeDados
                                        colSpan={headList[2].colSpan}
                                        bold={item.bold}
                                    >
                                        {formataTableCellBodyExibeDadosValor(item.valorCS, report, item.bold,
                                            false, aumentoLetra, aumentoLetraReport, values)}
                                    </TableCellBodyExibeDados>

                                    {values.exibirPercPremioAnualizadoAcumuladoEmRelacaoCapitalSegurado && (
                                        <TableCellBodyExibeDados
                                            colSpan={headList[3].colSpan}
                                            bold={item.bold}
                                        >
                                            {item.valorPremioAnualizadoAcumulado
                                                ?
                                                    formataTableCellBodyExibeDadosPerc(
                                                        (item.valorCS - item.valorPremioAnualizadoAcumulado) /
                                                            item.valorPremioAnualizadoAcumulado * 100,
                                                                report, item.bold, false, aumentoLetra, aumentoLetraReport, values)
                                                :
                                                    ''
                                            }
                                        </TableCellBodyExibeDados>
                                    )}

                                    <TableCellBodyExibeDados
                                        colSpan={headList[3 + colSpan].colSpan}
                                        bold={item.bold}
                                    >
                                        {formataTableCellBodyExibeDadosValor(item.valorPremioAnualizado, report,
                                            item.bold, false, aumentoLetra, aumentoLetraReport, values)}
                                    </TableCellBodyExibeDados>

                                    <TableCellBodyExibeDados
                                        colSpan={headList[4 + colSpan].colSpan}
                                        bold={item.bold}
                                    >
                                        {formataTableCellBodyExibeDadosValor(item.valorPremioAnualizadoAcumulado, report,
                                            item.bold, false, aumentoLetra, aumentoLetraReport, values)}
                                    </TableCellBodyExibeDados>
                                    
                                    <TableCellBodyExibeDados
                                        colSpan={headList[5 + colSpan].colSpan}
                                        bold={item.bold}
                                    >
                                        {!values.exibirValorResgateSomenteAPartirQuitacaoSeguroVidaInteira ||
                                        item.ano >= estrategiasFinanceirasTabelaEvolucaoValorResgate.anoQuitacaoVidaInteira
                                            ?
                                                formataTableCellBodyExibeDadosValor(item.valorResgate, report,
                                                    item.bold, false, aumentoLetra, aumentoLetraReport, values)
                                            :
                                                ''
                                    }
                                    </TableCellBodyExibeDados>

                                    {/*values.exibirEconomiaInventarioSeguroVidaTabelaEvolucaoValorResgate && (
                                        <>
                                            <TableCellBodyExibeDados
                                                colSpan={headList[5].colSpan}
                                                bold={item.bold}
                                            >
                                                {formataTableCellBodyExibeDadosValor(item.valorEconomiaInventarioSeguroVida,
                                                    report, item.bold, false, aumentoLetra, aumentoLetraReport, values)}
                                            </TableCellBodyExibeDados>

                                            {/ *
                                            <TableCellBodyExibeDados
                                                colSpan={headList[5].colSpan}
                                                bold={item.bold}
                                            >
                                                {formataTableCellBodyExibeDadosValor(item.valorResgateMaisEconomiaInventarioSeguroVida,
                                                    report, item.bold, false, aumentoLetra, aumentoLetraReport, values)}
                                            </TableCellBodyExibeDados>
                                            * /}
                                        </>
                                    )*/}
                                </TableRowBodyExibeDados>
                            )
                        })}
                    </TableBodyExibeDados>
                </TableExibeDados>

                {values.aplicarTaxaInflacaoTabelaEvolucaoValorResgate &&
                !estrategiasFinanceirasTabelaEvolucaoValorResgate.apenasExibirTabelaEvolucaoValorResgateSemTaxaInflacao &&
                (!indFinal || indFinal >= estrategiasFinanceirasTabelaEvolucaoValorResgate.tabelaEvolucaoValorResgate.length - 1) && (
                    <div
                        className='mt-5'
                        dangerouslySetInnerHTML={{ __html:
                            MESSAGE().tabelaEvolucaoValorResgateImportante.replace('$1$', formataPerc(values.taxaInflacaoAnual))}}
                    />
                )}
            </>
        )
    }

    return (
        estrategiasFinanceirasTabelaEvolucaoValorResgate.tabelaEvolucaoValorResgate.length > 0
            ?
                report || relatorioModoApresentacao(values)
                    ?
                        //<div
                        //    className={(!report && relatorioModoApresentacao(values) ? 'mt-10 ml-5 mr-5' : '')} // mudança da fonte: acrescentou mt-10
                        //>
                            <TabelaEvolucaoValorResgate/>
                        //</div>
                    :
                        /*
                        <GridContainer
                            className='justify-center'
                        >
                            <GridItem8>
                                <CardGridEstudo>
                                    <CardGridEstudoTabelaPadrao
                                        values={values}
                                        SvgIcon={""}
                                        label={LABEL.tabelaEvolucaoValorResgate + ': ' +
                                            estrategiasFinanceirasTabelaEvolucaoValorResgate.nomeFamiliar
                                        }
                                        helpTextMorte={""}
                                        helpTextInvalidez={""}
                                        component={<TabelaEvolucaoValorResgate/>}
                                        popup={false}
                                    />
                                </CardGridEstudo>
                            </GridItem8>
                        </GridContainer>
                        */
                        <GridContainer
                            className='justify-center'
                        >
                            <GridItem11>
                                <DivOverflowX>
                                    <TabelaEvolucaoValorResgate/>
                                </DivOverflowX>
                            </GridItem11>
                        </GridContainer>
            :
                ''
    )
}

export default EstudoFormTabelaEvolucaoValorResgate